import { render, staticRenderFns } from "./OrderTeamSelector.vue?vue&type=template&id=067d7dd6&"
import script from "./OrderTeamSelector.vue?vue&type=script&lang=js&"
export * from "./OrderTeamSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports